import React from "react";
import {connect} from "react-redux";
import {compose} from "recompose";
import {push} from "connected-react-router";

import {withStyles} from "@material-ui/core/styles";

import {DropzoneDialog} from 'material-ui-dropzone'
import QRCode from 'qrcode.react';

import {DialogTitle, DialogContent, DialogActions} from "./Dialog"

import Dispatch from "../../constant/dispatch";
import qrCode from "../../reducer/qrCodeReducer";
import Palette from "../../util/Palette";
import {IoIosAdd} from "react-icons/io";
import {Button, Dialog, Grid} from "@material-ui/core";
import ReactCrop from "react-image-crop";

const styles = theme => ({
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    menu: {
        width: 200,
    },
});

class ImageCropperDialog extends React.Component {

    onCropComplete(crop){
        try{
            let result = this.makeClientCrop(crop);
        }catch(e){
            console.log("error is ",e)
        }
        // console.log("this is ", result)
    };

    getCroppedImg(image, crop, fileName) {
        const canvas = document.createElement('canvas');
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        canvas.width = crop.width;
        canvas.height = crop.height;
        const ctx = canvas.getContext('2d');

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width,
            crop.height
        );

        return new Promise((resolve, reject) => {
            canvas.toBlob(blob => {
                if (!blob) {
                    //reject(new Error('Canvas is empty'));
                    console.error('Canvas is empty');
                    return;
                }
                blob.name = fileName;

                console.log("process is done")
                // window.URL.revokeObjectURL(this.fileUrl);
                // this.fileUrl = window.URL.createObjectURL(blob);

                this.props.onImageCropped(blob)

            }, 'image/png');
        });
    }

    async makeClientCrop(crop) {
        if (this.imageRef && crop.width && crop.height) {
            try {
                const croppedImageUrl = await this.getCroppedImg(
                    this.imageRef,
                    crop,
                    'cropped.png'
                );
            } catch (e) {
                console.log("found ya" , e)
            }

        }
    }

    onCropChange = (crop, percentCrop) => {
        // You could also use percentCrop:
        // this.setState({ crop: percentCrop });
        this.props.onCropChange(crop)
    };


    onImageLoaded = image => {
        this.imageRef = image;
    };

    render() {

        const classes = this.props.classes

        return <Dialog
            open={this.props.isOpen}
            maxWidth="md"
            fullWidth={true}>
            <DialogTitle onClose={this.props.onClose}>
                Crop Image
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={4} style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems : "center",
                    justifyContent :"center"
                }}>
                    <ReactCrop
                        src={this.props.src}
                        crop={this.props.crop}
                        ruleOfThirds
                        style={{
                            height: '10em',
                            overflow: false,
                            flex: 1,
                        }}
                        imageStyle={{
                            height : "60vh",
                            objectFit: 'contain',
                        }}
                        onComplete={crop=>this.onCropComplete(crop)}
                        onChange={this.onCropChange}
                        onImageLoaded={this.onImageLoaded}
                    />
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="text"
                    color="primary"
                    onClick={this.props.onNegativeButtonPressed}
                    className={classes.button}>
                    {this.props.negativeButtonText ? this.props.negativeButtonText : "Back"}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={this.props.onSubmit}
                    className={classes.button}>
                    SUBMIT
                </Button>
            </DialogActions>
        </Dialog>
    }
}

export default compose(
    withStyles(styles),
)(ImageCropperDialog);
